import { useSearchParams } from "react-router-dom";

/**
 * The filters of a queue page live in the address (`?type=work&q=…`), so Back from a
 * document returns to the same view. `change` sets the given values; an empty value removes
 * its parameter. Changing a filter replaces the address instead of adding a history step.
 */
export function useQueryParams() {
  const [params, setParams] = useSearchParams();

  const change = (changes: Record<string, string>) => {
    const next = new URLSearchParams(params);
    Object.entries(changes).forEach(([name, value]) => {
      if (value) next.set(name, value);
      else next.delete(name);
    });
    setParams(next, { replace: true });
  };

  return { params, change };
}
